module.exports = __webpack_public_path__ + "assets/img/flow2.fd95a6a8.png";